import { defineBlock, EditableText, InnerBlocks } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "Narrow Content",
  tags: ["#page"],
}

export default defineBlock("layout/narrow-content", (props) => {
  return (
    <div className="narrow-content content-sized block-spacing flex flex-col gap-10 items-center text-blue">
      <InnerBlocks
        allowedBlocks={["#inline"]}
        defaultBlocks={[
          [
            "core/paragraph",
            {
              className: "is-style-body-large",
              placeholder: "Enter large body text",
            },
          ],
          [
            "core/paragraph",
            {
              className: "is-style-body-small",
              placeholder: "Enter small body text",
            },
          ],
        ]}
        className="w-full md:w-narrowContentW mx-auto flex flex-col gap-5 items-start justify-center [&_p]:!my-0 [&_h3]:!type-title-s [&_h3]:w-full [&_h3]:text-center [&_.wp-block]:w-full [&_.inline-media]:!my-5 [&_.callout-card]:!my-5 [&_.pull-quote]:!my-5"
      />
    </div>
  )
})
